function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import tasks from '@/js/tasks';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import PaginationVue from '@/components/PaginationVue';
export default {
  name: 'AddSandboxBase',
  components: {
    PaginationVue: PaginationVue
  },
  props: {
    useCase: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    is_read: {
      type: Boolean,
      required: false,
      default: true
    },
    is_convert_idsandbox: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    businessUserServiceAccounts: function businessUserServiceAccounts(newVal) {
      console.log('businessUserServiceAccounts changed', newVal);
      if (!this.service_account && newVal.length && this.useCase.business_area) {
        this.setInitialServiceAccount();
      }
    }
  },
  data: function data() {
    return {
      loadingColumns: false,
      page: 1,
      pageCount: 0,
      partyIdSelected: null,
      itemsPerPage: 5,
      pagination: {
        current: 1,
        limit: 10,
        total: 0
      },
      valid: true,
      columns_selected: [],
      tablesSandbox: [],
      tableSearch: '',
      items: [],
      partyId: null,
      keySearchTable: 1,
      service_account: null,
      reason: ''
    };
  },
  created: function created() {
    this.setInitialServiceAccount();
    this.getTablesSandbox();
  },
  methods: {
    setInitialServiceAccount: function setInitialServiceAccount() {
      var target = (this.useCase.business_area_user || '').trim().toLowerCase();
      var match = this.businessUserServiceAccounts.find(function (acc) {
        return acc.name.trim().toLowerCase() === target;
      });
      console.log('MATCH:', match);
      this.service_account = match || null;
    },
    updateSelected: function updateSelected(value) {
      console.log('this.columns_selected:', this.columns_selected);
      this.columns_selected = value;
    },
    toggleSelectAll: function toggleSelectAll() {
      if (this.allSelected) {
        this.columns_selected = [];
      } else {
        this.columns_selected = this.items;
      }
    },
    reset: function reset() {
      this.columns_selected = [];
      this.tableSearch = '';
      this.items = [];
      this.partyId = null;
      this.reason = '';
      this.keySearchTable += 1;
      this.$refs.form.resetValidation();
    },
    getTablesSandbox: function getTablesSandbox() {
      var _this = this;
      if (this.useCase.source == 'ATHENA') {
        this.getTablesAWS();
        return;
      }
      UseCasesService.getSandboxItems(this.useCase.company_code, this.useCase.id).then(function (response) {
        console.log(response);
        var sandboxItems = response.data && response.data.sbx_items;
        if (sandboxItems && sandboxItems.TABLE) {
          _this.tablesSandbox = sandboxItems.TABLE;
        }
      }).catch(function (error) {
        console.error('Error al obtener tablas del Sandbox:', error);
        tasks.toast.error('Error al obtener tablas desde el Sandbox');
      });
    },
    getTablesAWS: function getTablesAWS() {
      var _this2 = this;
      var name = this.service_account && this.service_account.name ? this.service_account.name : '';
      if (!name) {
        console.warn('No se seleccionó ninguna cuenta de servicio.');
        return;
      }
      UseCasesService.getTablesAWS(name, this.is_read).then(function (response) {
        console.log(response);
        var sandboxItems = response.data && response.data.sbx_items;
        var noTables = !sandboxItems.TABLE || sandboxItems.TABLE.length === 0;
        if (noTables) {
          _this2.tablesSandbox = ['No se encontraron tablas disponibles en la base de datos.'];
        } else {
          _this2.tablesSandbox = sandboxItems.TABLE;
        }
      }).catch(function (error) {
        console.error('Error al obtener tablas de AWS:', error);
        tasks.toast.error('Error al obtener tablas desde AWS');
      });
    },
    onTableSelected: function () {
      var _onTableSelected = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$tableSearch$spl, _this$tableSearch$spl2, projectId, datasetId, tableName, response, name, _response, num_rows, num_cols, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loadingColumns = true;
              this.items = [];
              this.columns_selected = [];
              this.partyIdSelected = null;
              console.log('onTableSelected', this.tableSearch);
              _context.p = 1;
              if (!this.tableSearch.split('.').pop().startsWith('v_sand')) {
                _context.n = 2;
                break;
              }
              tasks.toast.warning('No se pueden seleccionar tablas que comiencen con "v_sand".');
              return _context.a(2);
            case 2:
              if (!(this.tablesSandbox.length > 0 && this.tableSearch !== '' && this.useCase.source !== 'ATHENA')) {
                _context.n = 4;
                break;
              }
              _this$tableSearch$spl = this.tableSearch.split('.'), _this$tableSearch$spl2 = _slicedToArray(_this$tableSearch$spl, 3), projectId = _this$tableSearch$spl2[0], datasetId = _this$tableSearch$spl2[1], tableName = _this$tableSearch$spl2[2];
              _context.n = 3;
              return UseCasesService.getSandboxTableSchemaFields(projectId, datasetId, tableName);
            case 3:
              response = _context.v;
              this.items = response.data.schema_fields;
              _context.n = 6;
              break;
            case 4:
              name = this.service_account && this.service_account.name ? this.service_account.name : '';
              _context.n = 5;
              return UseCasesService.getColumnsAWS(name, this.tableSearch, this.useCase.business_name, this.is_read);
            case 5:
              _response = _context.v;
              num_rows = _response.data.num_rows || 0;
              num_cols = _response.data.num_cols || 0;
              if (num_rows > 35000000 || num_cols > 900) {
                tasks.toast.warning('Los límites de columnas y filas se ha alcanzado.\n Por favor, seleccione una tabla con menos de 35 millones de filas y menos de 900 columnas.');
                this.items = [];
              } else {
                this.items = _response.data.schema_fields;
              }
            case 6:
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t = _context.v;
              console.error(_t);
              tasks.toast.error('Error al obtener columnas');
            case 8:
              _context.p = 8;
              this.keySearchTable += 1;
              this.loadingColumns = false;
              return _context.f(8);
            case 9:
              return _context.a(2);
          }
        }, _callee, this, [[1, 7, 8, 9]]);
      }));
      function onTableSelected() {
        return _onTableSelected.apply(this, arguments);
      }
      return onTableSelected;
    }(),
    selectAllItems: function selectAllItems(event) {
      console.log(event);
      this.$refs["DIALOG_CONFIRMATION_SELECT_ALL"].onOpen();
    },
    onConfirmSelectAll: function onConfirmSelectAll(event) {
      if (event) {} else {}
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    onSubmitEjemplo: function onSubmitEjemplo(event) {
      var _this3 = this;
      if (this.useCase.source == 'ATHENA') {
        console.log("this.usecase", this.useCase);
        // Motivo obligatorio en el flujo de exportar base (desencriptar id_sandbox).
        // La rama ATHENA no ejecuta this.validate(), por eso se valida explícitamente.
        if (this.is_convert_idsandbox && !(this.reason && this.reason.trim())) {
          tasks.toast.warning(this.translate('frases.reason_required'));
          return;
        }
        var _newColumnPartyId = this.items.find(function (element) {
          return element.name === _this3.partyIdSelected;
        });
        if ((_newColumnPartyId.type || '').toLowerCase() !== "string") {
          tasks.toast.warning("Debe seleccionar una columna de tipo STRING.");
          return;
        }
        var columnIdSandbox = this.columns_selected.find(function (element) {
          return element.name.toLowerCase() === 'id_sandbox';
        });
        if (!this.is_convert_idsandbox && columnIdSandbox) {
          tasks.toast.warning("La tabla contiene una columna llamada 'id_sandbox'. Verifíquela antes de continuar.");
          return;
        }
        console.log(this.columns_selected, 'columns selected');
        var columns = this.columns_selected.map(function (item) {
          return item.name;
        });
        var _newAttributes = this.columns_selected.map(function (item) {
          return {
            attribute_name: item.name,
            attribute_object_name: _this3.tableSearch,
            attribute_scheme_name: _this3.tableSearch,
            attribute_project_name: _this3.tableSearch,
            attribute_description: item.description || 'Atributo de tabla creada en Sandbox',
            is_partyid: _this3.partyId === item.name ? '1' : '0',
            is_external: '1',
            attribute_source_id: 1,
            attribute_filters: {},
            attribute_category: 'sandbox',
            attribute_dtype: item.type,
            attribute_notnull: -1,
            company_code_usr: _this3.useCase.company_code
          };
        });
        var _params = {
          company_code_usr: this.useCase.company_code,
          company_name: this.useCase.company_name,
          append: true,
          flag_data_ext: '1',
          applicant: this.userEmail,
          // Solicitude id 3: Añadir base Sandbox
          solicitude_type_id: 3,
          rdetail: _newAttributes,
          call_approval_method: false
        };
        var data = {
          business_name: this.useCase.business_name,
          company_code: this.useCase.company_code,
          usecase_id: this.useCase.id,
          business_unit: this.service_account && this.service_account.name ? this.service_account.name : '',
          table_name: this.tableSearch,
          params: _params,
          party_id: this.partyId,
          columns: columns,
          automatic_approve: false,
          creation_user: this.userEmail,
          partyid_match: '',
          access_deadline_date: this.useCase.access_deadline_date,
          convert_idsandbox: this.is_convert_idsandbox,
          reason: (this.reason || '').trim()
        };
        UseCasesService.postConvertPartyIdAWS(data).then(function (response) {
          console.log(response);
          tasks.toast.success(_this3.translate('success_messages.requested'), _this3.translate('titles.success'));
        }).catch(function (error) {
          console.error('Error al convertir Party ID en AWS:', error);
          var errorMsg = _this3.translate('error_messages.error_general');
          if (error.response && error.response.data && error.response.data.detail) {
            errorMsg = error.response.data.detail;
          }
          tasks.toast.error(errorMsg, _this3.translate('titles.error'));
        }).finally(function () {
          _this3.$emit('close');
        });
        return;
      }
      console.log('onSubmitEjemplo', event);
      console.log(this.useCase, 'use case');
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      var newColumnPartyId = this.items.find(function (element) {
        return element.name === _this3.partyIdSelected;
      });
      if ((newColumnPartyId.type || '').toLowerCase() !== "string") {
        tasks.toast.warning("Debe seleccionar una columna de tipo STRING.");
        return;
      }
      console.log(this.tableSearch, '--table search--');
      this.addPartyIdRow();
      var tableSplitted = this.tableSearch.split('.');
      var projectId = tableSplitted[0];
      var datasetId = tableSplitted[1];
      var objectId = tableSplitted[2];
      console.log(this.columns_selected, 'columns selected');
      var newAttributes = this.columns_selected.map(function (item) {
        return {
          attribute_name: item.name,
          attribute_object_name: objectId,
          attribute_scheme_name: datasetId,
          attribute_project_name: projectId,
          attribute_description: item.description || 'Atributo de tabla creada en Sandbox',
          is_partyid: _this3.partyId === item.name ? '1' : '0',
          is_external: '1',
          attribute_source_id: 1,
          attribute_filters: {},
          attribute_category: 'sandbox',
          attribute_dtype: item.type,
          attribute_notnull: -1,
          company_code_usr: _this3.companyCode
        };
      });
      var params = {
        company_code_usr: this.companyCode,
        company_name: this.useCase.company_name,
        append: true,
        flag_data_ext: '1',
        applicant: this.userEmail,
        // Solicitude id 3: Añadir base Sandbox
        solicitude_type_id: 3,
        rdetail: newAttributes,
        call_approval_method: false,
        access_deadline_date: this.useCase.access_deadline_date
      };
      UseCasesService.updateAttributesUseCase(this.useCase.company_code, this.useCase.id, false, params).then(function (response) {
        if (response.code === 202) {
          tasks.toast.success(response.message, _this3.translate('titles.success'));
        } else if (response.code === 200 && !params.call_approval_method) {
          if (response.data && response.data.automatic_creation) tasks.toast.success(_this3.translate('success_messages.general'), _this3.translate('titles.success'));else tasks.toast.success(_this3.translate('success_messages.requested'), _this3.translate('titles.success'));
        }
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this3.translate('error_messages.error_general'), _this3.translate('titles.error'));
      }).finally(function () {
        _this3.$emit('close');
      });
    },
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
        var _this4 = this;
        var newColumnPartyId, tableSplitted, projectId, datasetId, objectId, newAttributes, params;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              event.preventDefault();
              if (this.validate()) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              newColumnPartyId = this.items.find(function (element) {
                return element.name === _this4.partyIdSelected;
              });
              if (!((newColumnPartyId.type || '').toLowerCase() !== "string")) {
                _context2.n = 2;
                break;
              }
              tasks.toast.warning("Debe seleccionar una columna de tipo STRING.");
              return _context2.a(2);
            case 2:
              console.log(this.tableSearch, '--table search--');
              this.addPartyIdRow();
              tableSplitted = this.tableSearch.split('.');
              projectId = tableSplitted[0];
              datasetId = tableSplitted[1];
              objectId = tableSplitted[2];
              newAttributes = this.columns_selected.map(function (item) {
                return {
                  attribute_name: item.name,
                  attribute_object_name: objectId,
                  attribute_scheme_name: datasetId,
                  attribute_project_name: projectId,
                  attribute_description: item.description || 'Atributo de tabla creada en Sandbox',
                  is_partyid: _this4.partyId === item.name ? '1' : '0',
                  is_external: '1',
                  attribute_source_id: 1,
                  attribute_filters: {},
                  attribute_category: 'sandbox',
                  attribute_dtype: item.type,
                  attribute_notnull: -1,
                  company_code_usr: _this4.companyCode
                };
              }); // buscar duplicados
              // const useCaseResponse = await UseCasesService.getUseCaseById(this.useCase.company_code, this.useCase.id)
              // const attributes = useCaseResponse.data.attributes
              // const attributeToCheck = newAttributes[0]
              // const idToCheck = `${attributeToCheck.attribute_project_name}.${attributeToCheck.attribute_scheme_name}.${attributeToCheck.attribute_object_name}`
              // const hasNoDuplicates = attributes.every(item => {
              //   const baseId = `${item.attribute_project_name}.${item.attribute_scheme_name}.${item.attribute_object_name}`
              //   return idToCheck !== baseId
              // })
              // if (!hasNoDuplicates) {
              //   console.log(useCaseResponse.data.attributes)
              //   tasks.toast.error(this.translate('error_messages.duplicate_base'))
              //   this.reset()
              //   return
              // }
              params = {
                company_code_usr: this.companyCode,
                company_name: this.useCase.company_name,
                append: true,
                flag_data_ext: '1',
                applicant: this.userEmail,
                // Solicitude id 3: Añadir base Sandbox
                solicitude_type_id: 3,
                rdetail: newAttributes,
                call_approval_method: false,
                access_deadline_date: this.useCase.access_deadline_date
              }; //call_approval_method: this.columns_selected.length <= 2
              UseCasesService.updateAttributesUseCase(this.useCase.company_code, this.useCase.id, false, params).then(function (response) {
                if (response.code === 200 && params.call_approval_method) {
                  tasks.toast.success(_this4.translate('success_messages.general'), _this4.translate('titles.success'));
                } else if (response.code === 200 && !params.call_approval_method) {
                  if (response.data && response.data.automatic_creation) tasks.toast.success(_this4.translate('success_messages.general'), _this4.translate('titles.success'));else tasks.toast.success(_this4.translate('success_messages.requested'), _this4.translate('titles.success'));
                }
              }).catch(function (err) {
                console.error(err);
                tasks.toast.error(_this4.translate('error_messages.error_general'), _this4.translate('titles.error'));
              }).finally(function () {
                _this4.$emit('close');
              });
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }(),
    addPartyIdRow: function addPartyIdRow() {
      var _this5 = this;
      if (this.loadingColumns) {
        tasks.toast.warning("Espere a que se carguen las columnas antes de seleccionar un ID.");
        return;
      }
      this.partyId = this.partyIdSelected;
      console.log(this.partyId, this.partyIdSelected);
      if (this.partyId) {
        var indexColumn = this.columns_selected.findIndex(function (element) {
          return element.name === _this5.partyId;
        });
        var newColumnPartyId = this.items.find(function (element) {
          return element.name === _this5.partyIdSelected;
        });
        console.log(newColumnPartyId);
        if ((newColumnPartyId.type || '').toLowerCase() !== "string") {
          tasks.toast.warning("Debe seleccionar una columna de tipo STRING.");
          return;
        }
        if (newColumnPartyId.name.toLowerCase() !== 'id' && this.companyCode === '032') {
          tasks.toast.warning("El Party Id debe ser 'id'.");
          return;
        }
        if (indexColumn !== -1) {
          this.columns_selected.splice(indexColumn, 1);
          this.columns_selected.push(newColumnPartyId);
        } else {
          this.columns_selected.push(newColumnPartyId);
        }
      }
      // else {
      //   const columnPartyId = this.items.find(element => element.name === this.partyIdSelected)
      //   if (columnPartyId) {
      //     this.columns_selected.push(columnPartyId)
      //   }
      // }
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), mapState('attribute', ['businessUserServiceAccounts'])), {}, {
    headers: function headers() {
      return [{
        text: this.translate('table_add_ids.attribute'),
        value: 'name'
      }, {
        text: this.translate('table_add_ids.definition'),
        value: 'type'
      }];
    },
    allSelected: function allSelected() {
      // Verifica si todas las filas están seleccionadas
      return this.columns_selected.length === this.items.length;
    },
    indeterminate: function indeterminate() {
      // Verifica si algunas filas están seleccionadas, pero no todas
      return this.columns_selected.length > 0 && this.columns_selected.length < this.items.length;
    },
    rules: function rules() {
      var _this6 = this;
      return {
        reason: [function (v) {
          return !!(v && v.trim()) || _this6.translate('frases.reason_required');
        }],
        partyId: [function (v) {
          return !!v || 'Selecciona un Party Id';
        }, function (v) {
          if (_this6.companyCode === '032') {
            return v && v.toLowerCase() === 'id' || 'El Party Id debe ser "id".';
          }
          return true;
        }],
        format: this.companyCode !== '000' ? [function (v) {
          return !!v || 'Selecciona una tabla';
        }, function (v) {
          return /^[^.]*\.[^.]*\.[a-z0-9_]*$/.test(v) || 'El nombre de la tabla solo puede ser letras minúsculas, números y "_".';
        }, function (v) {
          return /^[^.]*\.[^.]*\.[^.]{3,20}$/.test(v) || 'Solo se permite entre 3 a 20 caracteres en el nombre de la tabla.';
        }, function (v) {
          var tableName = (v || '').split('.').pop();
          return !tableName.startsWith('v_sand') || 'No se permiten tablas que comiencen con "v_sand".';
        }] : []
      };
    },
    // partyIdSelected: {
    //   get() {
    //     return this.partyId
    //   },
    //   set(value) {
    //     if (this.partyId) {
    //       const indexColumn = this.columns_selected.findIndex(element => element.name === this.partyId)
    //       const newColumnPartyId = this.items.find(element => element.name === value)
    //       if (indexColumn !== -1) {
    //         this.columns_selected.splice(indexColumn, 1)
    //         this.columns_selected.push(newColumnPartyId)
    //       }
    //     } else {
    //       const columnPartyId = this.items.find(element => element.name === value)
    //       if (columnPartyId) {
    //         this.columns_selected.push(columnPartyId)
    //       }
    //     }
    //     this.partyId = value
    //   }
    // }
    label: function label() {
      return {
        add_sa_by_business_area: this.translate('attributes.label.add_sa_by_business_area')
      };
    }
  })
};